import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const BannerWrapper = styled.div`
  width: 100%;
  height: 150px;
  margin: 0 auto 0 auto;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
`;
const BannerImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  opacity: ${({ active }) => (active ? 1 : 0)};
  transform: translateX(${({ offset }) => offset}%);
  transition: opacity 0.5s, transform 0.5s;
  z-index: ${({ active }) => (active ? 2 : 1)};
`;
const BannerText = styled.div`
  position: absolute;
  left: 20px;
  bottom: 20px;
  color: ${({ color }) => color || '#fff'};
  font-size: 24px;
  font-weight: bold;
  text-shadow: 1px 1px 8px rgba(0,0,0,0.4);
`;
const SubText = styled.div`
  font-size: 18px;
  font-weight: 400;
  margin-top: 4px;
`;

const sampleImages = [
  '/banner_sample.png',
  '/nudok_sample.png',
  '/nupil_sample.png',
  '/moim_sample.png',
  'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1465101053361-7630cab8f5c1?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1465101011104-4e86c5a2e4c1?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1454023492550-5696f8ff10e1?auto=format&fit=crop&w=600&q=80',
];

const SectionBanner = ({ main, sub, color }) => {
  const [idx, setIdx] = useState(0);
  const [direction, setDirection] = useState(0); // -1: left, 1: right
  const total = sampleImages.length;
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  // 터치 스와이프
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const onTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const onTouchEnd = () => {
    if (touchStartX.current !== null && touchEndX.current !== null) {
      const diff = touchStartX.current - touchEndX.current;
      if (diff > 40) {
        setDirection(1);
        setIdx(idx === total - 1 ? 0 : idx + 1);
      } else if (diff < -40) {
        setDirection(-1);
        setIdx(idx === 0 ? total - 1 : idx - 1);
      }
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };

  return (
    <BannerWrapper
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {sampleImages.map((img, i) => {
        let offset = 0;
        if (i === idx) offset = 0;
        else if (i < idx) offset = direction === 1 ? -100 : -100;
        else offset = direction === 1 ? 100 : 100;
        return (
          <BannerImg
            key={img}
            src={img}
            alt={`배너${i+1}`}
            active={i === idx}
            offset={i === idx ? 0 : (i < idx ? -100 : 100)}
            draggable={false}
          />
        );
      })}
      <BannerText color={color}>
        {main}
        {sub && <SubText>{sub}</SubText>}
      </BannerText>
    </BannerWrapper>
  );
};

export default SectionBanner; 